import type { Activity } from '@epasu/core';
import { Card } from '@/components/ui/card';

interface Props {
  activities: Activity[];
}

/** Gemeinsamer Verlauf aller Ansprechpartner der Firma — rein lesend. */
export function TimelineTab({ activities }: Props) {
  return (
    <Card className="p-6">
      <h2 className="text-sm font-semibold">Verlauf</h2>
      {activities.length === 0 ? (
        <p className="mt-3 text-sm text-muted-foreground">Noch nichts passiert.</p>
      ) : (
        <ol className="mt-3 space-y-3">
          {activities.map((a) => (
            <li key={a.id} className="flex gap-3 text-sm">
              <time
                className="w-32 shrink-0 text-xs text-muted-foreground"
                dateTime={a.createdAt}
              >
                {new Date(a.createdAt).toLocaleString('de-DE', {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })}
              </time>
              <span>{a.summary}</span>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
